(function () {
    Drupal.behaviors.eventShare = {
        attach: (context) => {
            // If context is not a DOM element or document, convert it to one
            const contextElement = context instanceof Element || context instanceof Document
                ? context
                : document;

            // Find all share buttons that haven't been processed yet
            const buttons = contextElement.querySelectorAll('.event-teaser__tag-share button:not([data-once-eventShare])');

            buttons.forEach(button => {
                // Mark as processed using a data attribute (similar to .once())
                button.setAttribute('data-once-eventShare', '');

                button.addEventListener('click', function() {
                    const status = this.getAttribute('aria-expanded');

                    if (status === 'false') {
                        this.setAttribute('aria-expanded', 'true');
                    } else {
                        this.setAttribute('aria-expanded', 'false');
                    }

                    // Find the parent and then the share element within it
                    const parent = this.parentNode;
                    const shareElement = parent.querySelector('.share');
                    shareElement.classList.toggle('share-open');
                });
            });
        }
    };
})();